
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://drjnrnwglzkcfedtqkpp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRyam5ybndnbHprY2ZlZHRxa3BwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk4MTI1MTAsImV4cCI6MjA1NTM4ODUxMH0.YY24C4djw9DMMS3jrj6suUEDWDfZABg-tqLHvgGMWkA";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
